import React from 'react';
import useScrollOverflowHint from '../../hooks/useScrollOverflowHint';
import './BrowseSidebarSticky.css';

const BrowseSidebarSticky = ({ children }) => {
    const scrollRef = useScrollOverflowHint();

    return (
        <div className="browse-sidebar-sticky">
            <div ref={scrollRef} className="browse-sidebar-sticky__scroll" data-scroll-hint="none">
                {children}
            </div>
            <div className="browse-sidebar-scroll-fade browse-sidebar-scroll-fade--top" aria-hidden="true" />
            <div className="browse-sidebar-scroll-fade browse-sidebar-scroll-fade--bottom" aria-hidden="true" />
        </div>
    );
};

export default BrowseSidebarSticky;
